var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcCard02({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "card-02"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.9375 5.14875C0.937464 3.89688 1.9523 2.88202 3.20417 2.88202H12.8039C14.0554 2.88202 15.0705 3.89598 15.0706 5.14808L15.0708 11.1493C15.0708 12.4016 14.0556 13.4153 12.8041 13.4153L3.20432 13.4152C1.95251 13.4152 0.937707 12.4005 0.937671 11.1486L0.9375 5.14875ZM3.20417 4.21535C2.68869 4.21535 2.27082 4.63324 2.27083 5.14871L2.27085 5.68192H13.7373L13.7372 5.14813C13.7372 4.63296 13.3197 4.21535 12.8039 4.21535H3.20417ZM13.7373 7.01525H2.27089L2.271 11.1486C2.27102 11.6641 2.68888 12.0819 3.20433 12.0819L12.8041 12.082C13.32 12.082 13.7374 11.6645 13.7374 11.1494L13.7373 7.01525ZM3.73719 9.14859C3.73719 8.7804 4.03567 8.48192 4.40386 8.48192H6.40386C6.77205 8.48192 7.07053 8.7804 7.07053 9.14859C7.07053 9.51678 6.77205 9.81525 6.40386 9.81525H4.40386C4.03567 9.81525 3.73719 9.51678 3.73719 9.14859Z",
    fill: "#116584"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCard02);
export default __webpack_public_path__ + "static/media/ic-card-02.f932d99e9baa2a7064a40b0f12a4266f.svg";
export { ForwardRef as ReactComponent };